"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addBrackets = (leftBracket, rightBracket) => (value, index, array) => {
    return leftBracket + value + rightBracket;
};
exports.default = exports.addBrackets;
//# sourceMappingURL=add_brackets.js.map